import Vue from 'vue'
import App from './app.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import iView from 'iview'
import 'iview/dist/styles/iview.css'
import './theme/index.less'
import './styles/reset.css'

Vue.config.productionTip = false
Vue.use(iView)

/* eslint-disable no-new */
new Vue({
  	el: '#app',
  	router,
  	store,
  	components: { App },
  	template: '<App/>',
  	mounted () {
     	this.$store.commit('setMenuList');
  	}
})



// WEBPACK FOOTER //
// ./src/index.js